import { StaffStatus, SubscriptionType } from 'types';
import { generateQueryString } from '../strings/shared-helpers-strings';
import { employeeListService } from '@services/private/employee-management/employee-list.service';
import { is200xRange } from '@utils/utilities';
import { updateState } from '../update-state';

type listDataType = {
  page: number;
  size: number;
  sortName: string;
  sortType: string;
  schStaffSt: StaffStatus | '';
  staffSchGroup: 'sch_name' | 'sch_email' | 'sch_name_email' | '';
  schKeyword: string;
  staffMstList:
    | [
        {
          joinTp: SubscriptionType;
          regDt: string;
          userEmail: string;
          userName: string;
          userSeq: string;
          userSt: StaffStatus;
          userUid: string;
        },
      ]
    | [];
  totalCount: number;
};

export const getEmployeeManagementList = async (
  listData: listDataType,
  payload = [],
  stateSetter,
  fields,
) => {
  const {
    page,
    size,
    sortName,
    sortType,
    schStaffSt,
    staffSchGroup,
    schKeyword,
  } = listData;

  const queryString = generateQueryString(
    [
      { key: 'page', value: page },
      { key: 'size', value: size },
      { key: 'sortName', value: sortName },
      { key: 'sortType', value: sortType },
      { key: 'schStaffSt', value: schStaffSt },
      { key: 'staffSchGroup', value: staffSchGroup },
      { key: 'schKeyword', value: schKeyword },
    ].map((item) => {
      return fields.includes(item.key)
        ? payload.find((field) => {
            // @ts-ignore
            return field.key === item.key;
          })
        : item;
    }),
  );

  const { response, statusCode } = await employeeListService(queryString);

  if (response?.code === '1' && is200xRange(statusCode)) {
    const list = [
      {
        key: 'staffMstList',
        value: response?.result?.staffMstListInfo?.staffMstList,
      },
      {
        key: 'totalCount',
        value: response?.result?.staffMstListInfo?.totalCount,
      },
    ];

    payload.forEach((item) => {
      list.push(item);
    });

    updateState(list, stateSetter);
  }
};
